export default "__VITE_ASSET__BoOR_pIV__"